import { render, staticRenderFns } from "./diaolist.vue?vue&type=template&id=620ebd2d&scoped=true&"
import script from "./diaolist.vue?vue&type=script&lang=js&"
export * from "./diaolist.vue?vue&type=script&lang=js&"
import style0 from "./diaolist.vue?vue&type=style&index=0&id=620ebd2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ebd2d",
  null
  
)

export default component.exports